import styled from 'styled-components';

// Container for the notifications, centered in the viewport
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers the container */
  width: 60vw;
  background-color: white;
  margin-bottom: 50px;
`;

// Wrapper for each notification, with space between text and the notification box
export const NotificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%; /* Full width of the container */
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0 20px 0;
  width: 60vw;
`;

// Text above each notification, can be styled as needed
export const Text = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: white;
  margin-bottom: 8px;
`;

// Top bar for notifications header
export const TopBar = styled.div`
  display: flex;
  justify-content: space-between; /* Space between left and right parts */
  padding: 16px;
  background-color: white;
  width: 60vw; /* Same width as the container */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  position: relative;
  margin-top: 20px;
`;

// Notifications count circle
export const NotificationCount = styled.div`
  background-color: #9b5af8;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
`;

// Container for the mark as read and options
export const LeftBar = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

// Icon styles for the three dots and mark as read button
export const IconButton = styled.div`
  cursor: pointer;
  font-size: 18px;
  color: gray;

  &:hover {
    color: black;
  }
`;
